import React from "react"
import styles from "./CompanyOpportunitiesPage.module.scss"
import CompanyOpportunitiesContainer from "../../containers/CompanyOpportunitiesContainer/CompanyOpportunitiesContainer"

const CompanyDepartmentsPage = () => {
  return (
    <div className={styles.pageWrapper}>
      <CompanyOpportunitiesContainer />
    </div>
  )
}

export default CompanyDepartmentsPage
